var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9418 4.69118L14.9765 2.71899C13.5604 1.29799 13.0054 0.533571 12.2386 0.803811C11.2825 1.14077 11.5972 3.26692 11.5972 3.98471C10.1107 3.98471 8.56516 3.85259 7.09985 4.12787C2.26259 5.03664 0.75 8.96532 0.75 13.25C2.1191 12.2802 3.48683 11.247 5.13233 10.7976C7.18637 10.2365 9.48039 10.5042 11.5972 10.5042C11.5972 11.222 11.2825 13.3482 12.2386 13.6851C13.1075 13.9913 13.5604 13.1909 14.9765 11.7699L16.9418 9.79775C18.1473 8.58804 18.75 7.98318 18.75 7.24446C18.75 6.50575 18.1473 5.90089 16.9418 4.69118Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.082a482f0eda2798d05fe86e4f0bc38c.svg";
export { ForwardRef as ReactComponent };